var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 201,
    viewBox: "0 0 161 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1919)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650513,
    width: 160,
    height: 200,
    rx: 8,
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.516 179.81C25.556 179.81 27.652 178.21 27.652 175.634V175.426H25.748V175.634C25.748 177.282 24.708 178.146 22.532 178.146C20.02 178.146 18.804 176.962 18.804 174.29C18.804 171.618 20.02 170.418 22.532 170.418C24.708 170.418 25.748 171.298 25.748 172.93V173.154H27.652V172.93C27.652 170.37 25.54 168.77 22.516 168.77C19.188 168.77 16.98 170.946 16.98 174.29C16.98 177.634 19.188 179.81 22.516 179.81ZM31.261 179.81C33.069 179.81 34.333 179.01 34.749 177.666H34.861V179.65H36.445V174.818C36.445 172.914 35.309 171.538 32.781 171.538C30.253 171.538 28.749 172.898 28.749 174.706V174.77H30.461V174.706C30.461 173.538 31.181 173.058 32.653 173.058C34.173 173.058 34.749 173.522 34.749 174.834V175.298L31.133 175.682C29.565 175.858 28.573 176.498 28.573 177.73C28.573 179.042 29.613 179.81 31.261 179.81ZM30.301 177.618C30.301 176.994 30.733 176.786 31.629 176.674L34.749 176.322C34.749 177.89 33.533 178.562 31.725 178.562C30.733 178.562 30.301 178.258 30.301 177.618ZM41.7475 179.81C43.9875 179.81 45.4595 178.93 45.4595 177.442C45.4595 176.13 44.5955 175.49 42.7075 175.25L40.8675 174.994C39.6675 174.834 39.3475 174.61 39.3475 173.986C39.3475 173.234 39.8595 172.914 41.3155 172.914C43.0755 172.914 43.5555 173.41 43.5555 174.354V174.45H45.2675V174.402C45.2675 172.514 43.7955 171.538 41.3635 171.538C38.9155 171.538 37.6515 172.53 37.6515 173.922C37.6515 175.25 38.5635 175.89 40.0675 176.082L42.2435 176.37C43.3795 176.53 43.7635 176.738 43.7635 177.394C43.7635 178.098 43.2995 178.418 41.7475 178.418C40.0835 178.418 39.4595 178.082 39.4595 177.042V176.914H37.7315V176.962C37.7315 178.802 39.1875 179.81 41.7475 179.81ZM48.4343 179.65V175.794C48.4343 174.114 49.1063 173.09 50.9943 173.09C52.6423 173.09 53.3623 173.73 53.3623 175.33V179.65H55.0743V174.914C55.0743 172.978 54.0023 171.538 51.8103 171.538C49.7783 171.538 48.8023 172.786 48.5303 174.13H48.4343V168.93H46.7063V179.65H48.4343ZM63.1705 179.65L64.9305 175.074L65.5385 173.122H65.6665L66.2745 175.074L68.0185 179.65H70.1625L72.5785 171.698H70.8185L69.4905 176.21L69.1225 178.258H68.9945L68.4025 176.05L66.7225 171.698H64.5145L62.8505 176.05L62.2585 178.258H62.1305L61.7625 176.21L60.4345 171.698H58.6425L61.0265 179.65H63.1705ZM75.1843 170.77V168.93H73.4563V170.77H75.1843ZM75.1843 179.65V171.698H73.4563V179.65H75.1843ZM82.0004 179.65V178.098H80.5604C79.5684 178.098 79.1204 177.842 79.1204 176.866V173.138H82.0004V171.698H79.1204V169.954H77.4084V171.698H76.0644V173.138H77.4084V176.962C77.4084 178.898 78.4644 179.65 80.1764 179.65H82.0004ZM84.8093 179.65V175.794C84.8093 174.114 85.4813 173.09 87.3693 173.09C89.0173 173.09 89.7373 173.73 89.7373 175.33V179.65H91.4493V174.914C91.4493 172.978 90.3773 171.538 88.1853 171.538C86.1533 171.538 85.1773 172.786 84.9053 174.13H84.8093V168.93H83.0813V179.65H84.8093ZM96.5071 179.81C98.2991 179.81 99.4671 178.946 99.8031 177.362H99.9151V179.65H101.499V168.93H99.7711V173.858H99.6751C99.3551 172.514 98.2831 171.538 96.3951 171.538C93.9791 171.538 92.6031 173.202 92.6031 175.682C92.6031 178.13 93.9951 179.81 96.5071 179.81ZM94.3471 175.682C94.3471 173.762 95.3391 173.106 97.0031 173.106C98.7791 173.106 99.7711 173.938 99.7711 175.634V175.762C99.7711 177.426 98.7311 178.226 97.0351 178.226C95.3231 178.226 94.3471 177.586 94.3471 175.682ZM104.825 179.65V175.186C104.825 173.762 105.385 173.01 106.745 173.01C107.929 173.01 108.409 173.538 108.409 174.674V175.378H110.121V174.338C110.121 172.834 109.337 171.538 107.529 171.538C105.897 171.538 105.033 172.562 104.793 173.842H104.681V171.698H103.097V179.65H104.825ZM113.542 179.81C115.35 179.81 116.614 179.01 117.03 177.666H117.142V179.65H118.726V174.818C118.726 172.914 117.59 171.538 115.062 171.538C112.534 171.538 111.03 172.898 111.03 174.706V174.77H112.742V174.706C112.742 173.538 113.462 173.058 114.934 173.058C116.454 173.058 117.03 173.522 117.03 174.834V175.298L113.414 175.682C111.846 175.858 110.854 176.498 110.854 177.73C110.854 179.042 111.894 179.81 113.542 179.81ZM112.582 177.618C112.582 176.994 113.014 176.786 113.91 176.674L117.03 176.322C117.03 177.89 115.814 178.562 114.006 178.562C113.014 178.562 112.582 178.258 112.582 177.618ZM124.077 179.65L125.837 175.074L126.445 173.122H126.573L127.181 175.074L128.925 179.65H131.069L133.485 171.698H131.725L130.397 176.21L130.029 178.258H129.901L129.309 176.05L127.629 171.698H125.421L123.757 176.05L123.165 178.258H123.037L122.669 176.21L121.341 171.698H119.549L121.933 179.65H124.077ZM136.699 179.81C138.507 179.81 139.771 179.01 140.187 177.666H140.299V179.65H141.883V174.818C141.883 172.914 140.747 171.538 138.219 171.538C135.691 171.538 134.187 172.898 134.187 174.706V174.77H135.899V174.706C135.899 173.538 136.619 173.058 138.091 173.058C139.611 173.058 140.187 173.522 140.187 174.834V175.298L136.571 175.682C135.003 175.858 134.011 176.498 134.011 177.73C134.011 179.042 135.051 179.81 136.699 179.81ZM135.739 177.618C135.739 176.994 136.171 176.786 137.067 176.674L140.187 176.322C140.187 177.89 138.971 178.562 137.163 178.562C136.171 178.562 135.739 178.258 135.739 177.618ZM145.153 179.65V168.93H143.425V179.65H145.153Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.8237,
    y1: 131.118,
    x2: 28.8237,
    y2: -10.3968,
    stroke: "url(#paint0_linear_51_1919)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.8237,
    y1: 131.118,
    x2: 64.8237,
    y2: -10.3968,
    stroke: "url(#paint1_linear_51_1919)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.824,
    y1: 131.118,
    x2: 100.824,
    y2: -10.3968,
    stroke: "url(#paint2_linear_51_1919)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.824,
    y1: 131.118,
    x2: 135.824,
    y2: -10.3968,
    stroke: "url(#paint3_linear_51_1919)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 29.9795,
    x2: 198.245,
    y2: 29.9795,
    stroke: "url(#paint4_linear_51_1919)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 88.9795,
    x2: 198.245,
    y2: 88.9795,
    stroke: "url(#paint5_linear_51_1919)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 58.9795,
    x2: 198.245,
    y2: 58.9795,
    stroke: "url(#paint6_linear_51_1919)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1505,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "url(#paint7_linear_51_1919)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3999 41.0005C33.3999 39.8165 34.3599 38.8577 35.5427 38.8577H55.2564C56.4392 38.8577 57.3992 39.8176 57.3992 41.0005V52.143C57.3992 53.3269 56.4392 54.2858 55.2564 54.2858H35.5427C35.2613 54.2858 34.9827 54.2304 34.7227 54.1227C34.4627 54.015 34.2265 53.8571 34.0275 53.6582C33.8285 53.4592 33.6707 53.223 33.563 52.963C33.4553 52.703 33.3999 52.4244 33.3999 52.143V41.0005ZM41.114 46.5717C41.114 45.4351 41.5655 44.3451 42.3692 43.5414C43.1729 42.7377 44.2629 42.2861 45.3995 42.2861C46.5361 42.2861 47.6262 42.7377 48.4299 43.5414C49.2336 44.3451 49.6851 45.4351 49.6851 46.5717C49.6851 47.7083 49.2336 48.7984 48.4299 49.6021C47.6262 50.4058 46.5361 50.8573 45.3995 50.8573C44.2629 50.8573 43.1729 50.4058 42.3692 49.6021C41.5655 48.7984 41.114 47.7083 41.114 46.5717ZM53.1136 45.7146C52.8863 45.7146 52.6683 45.8049 52.5075 45.9656C52.3468 46.1264 52.2565 46.3444 52.2565 46.5717V46.5809C52.2565 47.054 52.6405 47.438 53.1136 47.438H53.1227C53.3501 47.438 53.5681 47.3477 53.7288 47.1869C53.8896 47.0262 53.9799 46.8082 53.9799 46.5809V46.5717C53.9799 46.3444 53.8896 46.1264 53.7288 45.9656C53.5681 45.8049 53.3501 45.7146 53.1227 45.7146H53.1136ZM36.8284 46.5717C36.8284 46.3444 36.9187 46.1264 37.0794 45.9656C37.2402 45.8049 37.4582 45.7146 37.6855 45.7146H37.6946C37.922 45.7146 38.14 45.8049 38.3007 45.9656C38.4614 46.1264 38.5517 46.3444 38.5517 46.5717V46.5809C38.5517 46.8082 38.4614 47.0262 38.3007 47.1869C38.14 47.3477 37.922 47.438 37.6946 47.438H37.6855C37.4582 47.438 37.2402 47.3477 37.0794 47.1869C36.9187 47.0262 36.8284 46.8082 36.8284 46.5809V46.5717Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3995 44.0212C44.7231 44.0212 44.0744 44.2899 43.5961 44.7682C43.1178 45.2465 42.8491 45.8952 42.8491 46.5716C42.8491 47.248 43.1178 47.8967 43.5961 48.375C44.0744 48.8533 44.7231 49.122 45.3995 49.122C46.0759 49.122 46.7246 48.8533 47.2029 48.375C47.6812 47.8967 47.9499 47.248 47.9499 46.5716C47.9499 45.8952 47.6812 45.2465 47.2029 44.7682C46.7246 44.2899 46.0759 44.0212 45.3995 44.0212Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.792 55.4236V59.1421C50.792 61.4153 51.695 63.5954 53.3024 65.2028C54.9098 66.8102 57.0899 67.7133 59.3632 67.7133H61.666C63.4842 67.7132 65.228 66.9909 66.5138 65.7053L68.4977 63.7214C69.7175 62.5012 70.4324 60.8661 70.5 59.1421H70.5057V55.7068C70.506 55.539 70.5394 55.3729 70.6039 55.218C70.6684 55.0631 70.7628 54.9224 70.8817 54.8039C71.1128 54.5609 71.2398 54.237 71.2356 53.9016C71.2313 53.5662 71.0961 53.2457 70.8588 53.0086C70.6215 52.7714 70.301 52.6364 69.9656 52.6324C69.6301 52.6283 69.3064 52.7555 69.0634 52.9869C68.3442 53.7052 67.9383 54.6788 67.9343 55.6953V58.285C67.9343 58.5123 67.844 58.7303 67.6833 58.8911C67.5226 59.0518 67.3045 59.1421 67.0772 59.1421C65.4913 59.1396 63.9264 59.5054 62.5059 60.2106C62.8724 59.5016 63.3988 58.8876 64.0434 58.4169C64.688 57.9463 65.4332 57.6319 66.2201 57.4987V44.9997C66.2201 44.6587 66.0846 44.3317 65.8435 44.0906C65.6024 43.8494 65.2754 43.714 64.9344 43.714C64.5934 43.714 64.2664 43.8494 64.0253 44.0906C63.7842 44.3317 63.6487 44.6587 63.6487 44.9997V53.4314C63.1002 53.1149 62.5254 52.8634 61.9345 52.6783V43.2854C61.9345 42.9444 61.7991 42.6174 61.5579 42.3763C61.3168 42.1352 60.9898 41.9998 60.6488 41.9998C60.3079 41.9998 59.9808 42.1352 59.7397 42.3763C59.4986 42.6174 59.3632 42.9444 59.3632 43.2854V52.2852C59.093 52.2852 58.823 52.298 58.554 52.3236V52.9739C58.554 54.3275 57.489 55.4236 56.1768 55.4236H50.792Z",
    fill: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1505,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint8_linear_51_1919)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_1919",
    x1: 29.3237,
    y1: 9.68107,
    x2: 29.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_1919",
    x1: 65.3237,
    y1: 9.68107,
    x2: 65.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_1919",
    x1: 101.324,
    y1: 9.68107,
    x2: 101.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_1919",
    x1: 136.324,
    y1: 9.68107,
    x2: 136.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_1919",
    x1: -60.1421,
    y1: 30.4795,
    x2: 195.012,
    y2: 30.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_1919",
    x1: -60.1421,
    y1: 89.4795,
    x2: 195.012,
    y2: 89.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_1919",
    x1: -60.1421,
    y1: 59.4795,
    x2: 195.012,
    y2: 59.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_1919",
    x1: 52.5,
    y1: 16.6505,
    x2: 52.5,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_1919",
    x1: 52.5,
    y1: 16.6505,
    x2: 52.5,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1919"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650513,
    width: 160,
    height: 200,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact6);
export default __webpack_public_path__ + "static/media/contact6.537e2a4e942fa0ae9fa760f37b27d0f6.svg";
export { ForwardRef as ReactComponent };